import React from 'react';
import { WT_TOKENS } from '../../warm-transfer/config';
import { Icon } from '../Icon/Icon';

export interface WarmTransferAICallSummaryProps {
  points: string[];
}

export function WarmTransferAICallSummary({ points }: WarmTransferAICallSummaryProps) {
  return (
    <div
      className="relative overflow-hidden rounded-[14px] px-[18px] pb-3.5 pt-4"
      style={{
        background: WT_TOKENS.greenWash,
        border: `1px solid ${WT_TOKENS.greenSoft}`,
      }}
    >
      <div
        className="absolute left-0 right-0 top-0 h-0.5 opacity-50"
        style={{ background: WT_TOKENS.iriLinear }}
      />
      <div className="mb-3 flex items-center gap-2">
        <Icon kind="sparkle" size={14} color={WT_TOKENS.greenDeep} stroke={2} />
        <h3
          className="m-0 text-[13px] font-bold uppercase tracking-[0.08em]"
          style={{ color: WT_TOKENS.greenDeep }}
        >
          AI call summary
        </h3>
      </div>
      <div className="flex flex-col gap-2.5">
        {points.map((point, i) => (
          <div key={point} className="grid grid-cols-[20px_1fr] items-start gap-2.5">
            <div
              className="mt-px inline-flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full text-[10.5px] font-bold"
              style={{ background: WT_TOKENS.greenSoft, color: WT_TOKENS.greenDeep }}
            >
              {i + 1}
            </div>
            <p className="m-0 text-[13.5px] font-medium leading-[1.55] tracking-[-0.005em] text-[var(--ink-0)]">
              {point}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
